export default "__VITE_ASSET__6b1ac0f7__"